import { Exclude } from 'class-transformer';
import { IsNumber, IsOptional, IsUUID } from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../base.dto';
import { DiagnosisDto } from './diagnosis.dto';

export interface DifferentialDiagnosisDto extends BaseDto {
  conditionDiagnosisId: string;
  /** @deprecated Use conditionDiagnosisId */
  skinConditionDiagnosisId?: string;
  diagnosis: DiagnosisDto;
  diagnosisId: string;
  order: number;
}

export class CreateDifferentialDiagnosisDto
  extends BaseCreateDto
  implements Partial<DifferentialDiagnosisDto>
{
  @Exclude()
  conditionDiagnosisId: never;

  @Exclude()
  /** @deprecated Use conditionDiagnosisId */
  skinConditionDiagnosisId: never;

  @Exclude()
  diagnosis: never;

  @IsUUID()
  diagnosisId: string;

  @IsNumber()
  order: number;
}

export class UpdateDifferentialDiagnosisDto
  extends BaseUpdateDto
  implements Partial<DifferentialDiagnosisDto>
{
  @Exclude()
  conditionDiagnosisId: never;

  @Exclude()
  /** @deprecated Use conditionDiagnosisId */
  skinConditionDiagnosisId: never;

  @Exclude()
  diagnosis: never;

  @IsOptional()
  @IsNumber()
  order: number;

  @IsOptional()
  @IsUUID()
  diagnosisId?: string;
}
